import { Link, useParams } from "react-router-dom";
import JobKeyLogo from "@/components/JobKeyLogo";

const P = ({ children }) => <p className="mb-4">{children}</p>;

function Terms() {
  return (
    <>
      <h2>1. About Jobky</h2>
      <P>Jobky ("Jobky", "we"), operated by [Your legal business name], offers a subscription software workspace for planning and producing short social videos, available at jobky.in.</P>
      <h2>2. Subscription and billing</h2>
      <P>Access to the AI features requires an active plan: Rs. 999 per month or Rs. 9,990 per year, in each case plus 18% GST. Prices are shown on the Pricing page and can be edited by the operator. Subscriptions renew automatically (monthly) or expire after 12 months (yearly) unless renewed. Wallet credit is prepaid and used only for the paid actions listed on the Billing page.</P>
      <h2>3. Acceptable use</h2>
      <P>You agree not to misuse the service, including: generating unlawful, hateful or misleading content, reselling access, scraping, or circumventing rate limits. We may suspend accounts that put the service or other users at risk.</P>
      <h2>4. AI output</h2>
      <P>AI-generated scripts, prompts, translations and plans are suggestions. You are responsible for reviewing them before use, for the content of anything you publish, and for following each platform's terms.</P>
      <h2>5. Your data</h2>
      <P>Your scripts, settings and metrics are stored for you per our Privacy Policy. You can export your work from the app at any time.</P>
      <h2>6. Liability</h2>
      <P>The service is provided "as is". To the extent permitted by law, our total liability to you is limited to the fees you paid us in the 3 months before the claim.</P>
      <h2>7. Contact</h2>
      <P>Questions about these terms: [support@jobky.in / your registered address].</P>
    </>
  );
}

function Privacy() {
  return (
    <>
      <h2>1. What we collect</h2>
      <P>Account details (name, email), billing details (state and optional GSTIN for invoices; payments are processed by Razorpay and we do not store card details), the content you create in the app, and technical logs.</P>
      <h2>2. How we use it</h2>
      <P>To run the service, process payments, send transactional email (verification, password reset, invoices), provide support, and prevent abuse. We do not sell your data.</P>
      <h2>3. Processors</h2>
      <P>Razorpay (payments), our email provider (transactional email), and our AI model provider (Anthropic) process data on our behalf to deliver the service.</P>
      <h2>4. Retention</h2>
      <P>We keep your account data while your account is open. You can request deletion at [support contact]; we keep invoice records as required by Indian tax law.</P>
      <h2>5. Your rights</h2>
      <P>You can access, correct or delete your personal data, or ask questions about privacy, by writing to [support@jobky.in].</P>
      <h2>6. Cookies</h2>
      <P>We use essential cookies for login sessions and local storage in your browser to remember your work in the app. No advertising trackers.</P>
    </>
  );
}

function Refund() {
  return (
    <>
      <h2>Subscription</h2>
      <P>Monthly subscriptions can be cancelled any time from the Billing page; access continues until the end of the paid period. Yearly plans can be cancelled within 7 days of purchase for a pro-rata refund of the unused months, minus GST already remitted, by writing to [support contact].</P>
      <h2>Wallet credit</h2>
      <P>Wallet credit is a prepaid balance used for paid actions. Used credit is non-refundable. Unused credit may be refunded at the operator's discretion within 14 days of recharge if it has not been used; credit expires 12 months after the recharge.</P>
      <h2>Failed payments and chargebacks</h2>
      <P>Failed payments are handled through the payment gateway. Chargebacks may result in suspension of the account until resolved.</P>
      <h2>How to ask</h2>
      <P>Write to [support@jobky.in] with your invoice number. Refunds, where approved, return to the original payment method within 5–7 working days.</P>
    </>
  );
}

export default function Legal() {
  const { page } = useParams();
  const pages = {
    terms: { title: "Terms of service", body: <Terms /> },
    privacy: { title: "Privacy policy", body: <Privacy /> },
    refund: { title: "Refund policy", body: <Refund /> },
  };
  const current = pages[page] || pages.terms;
  return (
    <div className="min-h-screen bg-bg">
      <header className="border-b border-line/60 bg-surface">
        <div className="mx-auto flex h-16 max-w-3xl items-center justify-between px-5">
          <Link to="/" data-testid="legal-logo"><JobKeyLogo /></Link>
          <Link to="/" className="text-sm font-bold text-accent">Back home</Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-5 py-14" data-testid="legal-page">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted">Legal</p>
        <h1 className="mt-2 font-display text-4xl font-extrabold tracking-tight">{current.title}</h1>
        <p className="mt-2 rounded-lg bg-warn/10 px-3 py-2 text-xs text-warn">
          Placeholder document — the operator fills in the bracketed business details.
        </p>
        <div className="prose-legal mt-8">{current.body}</div>
        <p className="mt-10 text-sm text-muted">Last updated: [date] · Questions? See our <Link to="/contact" className="text-accent underline">Contact page</Link>.</p>
      </main>
    </div>
  );
}
